import React, { Component } from 'react';
import InfoBox from './InfoBox.js';
import ChefHatGold from '../../../svg/ChefHatGold.js';
import Formsy from 'formsy-react';
import FormsySelectMui from '../../form/FormsySelectMui';
import { getWeeklyHourOptions } from '../../../helpers/hourOptions';
import { daysOfWeek } from '../../../helpers/selectOptions';

class Chef extends Component {
  state = {
    serviceDayOfWeek: '',
    serviceTime: '',
    hourOptions: [],
    isCurrentStep: false
  };
  render() {
    const { setStepAsValid, setStepAsInvalid } = this.props;
    const { serviceDayOfWeek, serviceTime, isCurrentStep } = this.state;

    return (
      <React.Fragment>
        <InfoBox
          headline="When would you like your chef to arive?"
          subline="Your chef will be in your home for about 4 hours. You can change this preference at any time. Please note that Monday and Tuesday time slots are limited and on a first-come first-serve basis. We will do our best to find a time that works for you!"
          icon={<ChefHatGold />}
        />
        <Formsy
          onValid={() => setStepAsValid(isCurrentStep)}
          onInvalid={() => setStepAsInvalid(isCurrentStep)}
          className="onboarding-new__form"
        >
          <div className="row">
            <div className="row__item row__item--full">
              <FormsySelectMui
                name="serviceDayOfWeek"
                placeholder="Day"
                value={serviceDayOfWeek}
                options={daysOfWeek}
                onChange={this.handleChange}
                showError={this.state.formIsInvalid}
                required
              />
            </div>
          </div>

          <div className="row">
            <div className="row__item row__item--full">
              <FormsySelectMui
                name="serviceTime"
                placeholder="Start Time"
                value={serviceTime}
                options={this.state.hourOptions}
                onChange={this.handleChange}
                showError={this.state.formIsInvalid}
                required
              />
            </div>
          </div>
        </Formsy>
      </React.Fragment>
    );
  }

  handleChange = e => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleClientUpdate = () => {
    const { serviceTime, serviceDayOfWeek } = this.state;

    const updatedClient = {
      client_service_preferences: [
        {
          start_time: serviceTime,
          day_of_week: serviceDayOfWeek
        }
      ]
    };
    this.props.updateClient(updatedClient);
  };

  componentDidMount = () => {
    const hourOptions = getWeeklyHourOptions();
    this.setState({ hourOptions });

    const { client } = this.props;
    if (client.client_service_preferences.length > 0) {
      const { day_of_week, start_time } = client.client_service_preferences[0];
      this.setState({
        serviceTime: start_time,
        serviceDayOfWeek: day_of_week
      });
    }
  };

  componentDidUpdate(prevProps) {
    const { hasSubmitted, isCurrentStep, client } = this.props;

    if (prevProps.client !== client) this.setState({ client });

    if (prevProps.isCurrentStep !== isCurrentStep)
      this.setState({ isCurrentStep });

    if (
      isCurrentStep &&
      hasSubmitted !== prevProps.hasSubmitted &&
      hasSubmitted === true
    ) {
      // Watch for next button click then update client in parent component
      this.handleClientUpdate();
    }
  }
}

export default Chef;



// WEBPACK FOOTER //
// ./src/components/new/onboarding/Chef.js